import React, { Component } from 'react';
import {FaIcon} from "../../FaIcon";
import {Spinner} from "../../Spinner";
import {HELP_LOOKER_CC, LinkToArticle} from "../../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

class LookerCCStatusClass extends Component {
    render() {
        const { t } = this.props;
        const { looker_cc_status_data } = this.props;

        if (!looker_cc_status_data) {
            if(!this.props.hasConnection) {
                return (
                    <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description status-no-included">
                            {t('looker_cc.not_included_or_not_connected')}
                        </p>
                    </div>
                </div>
                );
            }

            return (
                <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description status-no-included">
                            {t('looker_cc.not_included_tooltip')}<br/><br/>{t('looker_cc.not_included_contact')}<br/><br/>
                            {t('looker_cc.special_description')}<br/><br />
                            &nbsp;&nbsp;➡️<LinkToArticle article={HELP_LOOKER_CC}/>
                        </p>
                    </div>
                </div>
            );
        }

        const { status, completed_percentage } = looker_cc_status_data;

        if (status === "COMPLETE" || (completed_percentage && completed_percentage >= 100)) {
            return (
                <div className={"bu-cell-icon fa-icon status-ok"}>
                    <FaIcon iconName="check-circle"/>
                </div>
            );
        }

        if (status === "PROCESSING") {
            return (
                <div className={"bu-cell-icon fa-icon status-loading"}>
                    <Spinner color="positive small" />
                    <div className="bu-tooltip looker-cc-tooltip">
                        <p className="tooltip-description">
                            {t('looker_cc.processing_tooltip', { percentage: completed_percentage || 0 })} <br/><br/>
                            {t('looker_cc.processing_connection_issue')}<br/>
                            {t('looker_cc.processing_contact')}
                        </p>
                    </div>
                </div>
            );
        }

        return (
            <div className={"bu-cell-icon"}>
                <FaIcon iconName={"exclamation-triangle"} />
                 <div className="bu-tooltip">
                    <p className="tooltip-description">
                        {t('looker_cc.unknown_status')}
                    </p>
                </div>
            </div>
        );
    }
}

export const LookerCCStatus = withTranslation()(LookerCCStatusClass);